import { useMutation } from '@tanstack/vue-query';

import { ACCESS_TOKEN_STORAGE_KEY, REFRESH_TOKEN_STORAGE_KEY } from '~/constants';
import storage from '~/foundation/storage/localstorage';
import keycloackApi from '~/services/keycloack-api/keycloack-api';
import queryClient, { queryKeys } from '~/store/queryClient';

export default function useLogout() {
  const mutationKey = queryKeys.AUTH.LOGOUT;

  async function mutationFn() {
    const refreshToken = storage.get<string>(REFRESH_TOKEN_STORAGE_KEY);
    if (!refreshToken) throw new Error('REFRESH_TOKEN_NOT_FOUND');
    return keycloackApi.logout(refreshToken);
  }

  return useMutation({
    mutationFn,
    mutationKey,
    onSettled() {
      storage.remove(ACCESS_TOKEN_STORAGE_KEY);
      storage.remove(REFRESH_TOKEN_STORAGE_KEY);
      window.location.href = '/';
      queryClient.refetchQueries({ queryKey: queryKeys.AUTH.STATUS });
    },
    retry: 5,
    retryDelay: 500,
  });
}
